import { Component, OnInit, Input, OnChanges, Inject, ChangeDetectorRef, Output, EventEmitter, ViewEncapsulation } from '@angular/core';
import { CommissionResult } from '../../models';
import { CommissionType, CommissionCalcType } from '../../types';
import { APP_CONFIG, IAppConfig } from '@app/core/config';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { TcCurrencyPipe } from '@app/shared/pipes';

@Component({
    selector: 'tc-commission-exchange-first',
    imports: [
        CommonModule,
        TranslateModule,
        TcCurrencyPipe
    ],
    templateUrl: './commission-exchange-first.component.html',
    styleUrls: ['./commission-exchange-first.component.scss'],
    encapsulation: ViewEncapsulation.None
})
export class CommissionExchangeFirstComponent implements OnInit, OnChanges {
  @Output() timerExpiredEmit = new EventEmitter<void>();
  @Input() commission: CommissionResult;
  @Input() calculateLoading: boolean;
  @Input() getAmountTitle: string;
  @Input() payAmountTitle: string;
  @Input() isDetailsMode: boolean;


  // data
  interval: number;
  pointPrecision: number;

  // types
  commissionType = CommissionType;
  commissionCalcType = CommissionCalcType;


  // boolean
  commissionIsExpired = false;

  constructor(
    @Inject(APP_CONFIG) private appConfig: IAppConfig,
    private cdRef: ChangeDetectorRef
  ) { }

  /*******************************************************************
    Lifecycle Hook
  *******************************************************************/

  ngOnInit() {
    this.setInterval();
    this.pointPrecision = this.appConfig.pointPrecision;
  }

  ngOnChanges(): void {
    this.setInterval();
    this.commissionIsExpired = false;
    this.cdRef.detectChanges();
  }

  private setInterval(): void {
    if (this.commission) {
      this.interval = Math.floor(this.commission.refreshTime / 1000);
    }
  }

  onTimerFinished(): void {
    this.commissionIsExpired = true;
    setTimeout(() => {
      this.timerExpiredEmit.emit();
    }, 50);
  }

}
